const activeConfigurationIds = new Set<string>();

/**
 * Keeps one direct mutation active per editable configuration.
 * Competing commands are rejected rather than queued so stale work cannot execute
 * after the application has adopted a replacement configuration.
 */
export const withConfiguratorMutationLock = async <T>(configId: string, operation: () => Promise<T>): Promise<T> => {
  if (activeConfigurationIds.has(configId)) {
    throw new Error("A configurator mutation is already active for this configuration.");
  }

  activeConfigurationIds.add(configId);
  try {
    return await operation();
  } finally {
    activeConfigurationIds.delete(configId);
  }
};
